<div class="sp-dialog__max-width-m sp-dialog__min-width">
  <div class="sp-width__full sp-row__end">
    <button (click)="onCloseClick()" mat-icon-button class="sp-icon__button sp-icon__button-accent">
      <mat-icon>clear</mat-icon>
    </button>
  </div>
  <div class="sp-padding__x2">
    <h3 class="sp-color__accent">{{ 'CLUSTER.DELETE_TAN_MAX_TITLE' | translate }}</h3>
    <p class="sp-margin__top">{{ 'CLUSTER.DELETE_TAN_MAX_MESSAGE' | translate }}</p>
    <app-shared-button
      class="sp-width__full sp-margin__top"
      [button_class]="'sp-button__warn'"
      [spinner_class]="'sp-spinner__warn'"
      [cta]="'GENERAL.DELETE_CTA'"
      [is_disabled]="is_delete_running"
      [is_spinner_visible]="is_delete_running"
      (click)="onDeleteClick()"></app-shared-button>
  </div>
</div>